import { createAction } from '@reduxjs/toolkit';
export const FETCH_ANALYTIC_DOMAIN_DATA = 'FETCH_ANALYTIC_DOMAIN_DATA';
export const fetchAnalyticDomainDataAction = createAction(FETCH_ANALYTIC_DOMAIN_DATA);